import { render, staticRenderFns } from "./SectionSubscriptionConfig.vue?vue&type=template&id=57aa6126&scoped=true&"
import script from "./SectionSubscriptionConfig.vue?vue&type=script&lang=js&"
export * from "./SectionSubscriptionConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa6126",
  null
  
)

export default component.exports